const ACCEPT_PARTIAL_BOOKING_DETAILS = {
  optional_fields: {
    bookedTickets: {},
    bookedOutboundTickets: {},
    bookedReturnTickets: {}
  },
  optional_definitions: `
    bookedTickets?: BookedTickets;
    bookedOutboundTickets?: BookedTickets;
    bookedReturnTickets?: BookedTickets;
  `
};

const AUTH_PROVIDERS_NAME = `"apple" | "google" | "facebook"`;

module.exports = [
  {
    code: 1,
    type: "T",
    part: "GE",
    action: "error",
    name: "UserError",
    message: "Generic user error",
    user_visible: true,
    response_code: 400
  },
  {
    code: 2,
    type: "T",
    part: "GE",
    action: "error",
    name: "OperationalError",
    message: "Generic operational error",
    user_visible: false,
    response_code: 500
  },
  {
    code: 6,
    type: "T",
    part: "GE",
    action: "error",
    name: "ExternalError",
    message: "Generic external error",
    user_visible: false,
    response_code: 500
  },

  {
    code: 5,
    type: "O",
    part: "GE",
    action: "error",
    name: "NotImplemented",
    message: "Code path not implemented",
    user_visible: false,
    response_code: 405
  },
  {
    code: 7,
    type: "O",
    part: "GE",
    action: "error",
    name: "ValidationError",
    user_visible: false,
    response_code: 422
  },
  {
    code: 8,
    type: "O",
    part: "GE",
    action: "error",
    name: "VersionError",
    message: "Unsupported version",
    response_code: 406
  },
  {
    code: 55,
    type: "T",
    part: "GE",
    action: "error",
    name: "AdapterError",
    message: "Generic adapter error",
    user_visible: false,
    response_code: 500
  },
  {
    code: 56,
    type: "U",
    part: "GE",
    action: "error",
    name: "Forbidden",
    message: "Forbidden",
    response_code: 403
  },

  // Basic validation errors
  {
    code: 3,
    type: "U",
    part: "GE",
    action: "correct",
    name: "InputMissing",
    message: "",
    response_code: 400
  },
  {
    code: 4,
    type: "U",
    part: "GE",
    action: "correct",
    name: "InputInvalid",
    message: "",
    response_code: 400
  },
  {
    code: 9,
    type: "U",
    part: "GE",
    action: "correct",
    name: "EmailUserExists",
    message: "Another user with that email already exists",
    user_visible: true,
    response_code: 409
  },
  {
    code: 10,
    type: "U",
    part: "GE",
    action: "correct",
    name: "InvalidPhoneNumber",
    message: "This phone number is invalid",
    user_visible: true,
    response_code: 400
  },
  {
    code: 11,
    type: "U",
    part: "GE",
    action: "correct",
    name: "NoUser",
    message: "The user does not exist",
    user_visible: true,
    response_code: 404
  },
  {
    code: 12,
    type: "U",
    part: "GE",
    action: "correct",
    name: "SignInWithEmail",
    message: "A user connected with email exists for this facebook user",
    user_visible: true,
    response_code: 422
  },
  {
    code: 13,
    type: "U",
    part: "GE",
    action: "correct",
    name: "FBUserExists",
    message: "A user with a facebook account already exists",
    user_visible: true,
    response_code: 409
  },
  {
    code: 14,
    type: "O",
    part: "GE",
    action: "error",
    name: "FBTokenMismatch",
    message: "ID and token do not match.",
    user_visible: false,
    response_code: 401
  },
  {
    code: 15,
    type: "O",
    part: "GE",
    action: "error",
    name: "FBPlatformError",
    message: "Error from the facebook API",
    user_visible: false,
    response_code: 500
  },
  {
    code: 16,
    type: "U",
    part: "GE",
    action: "correct",
    name: "PasswordInvalid",
    message: "The password is invalid",
    user_visible: true,
    response_code: 401
  },
  {
    code: 17,
    type: "U",
    part: "GE",
    action: "correct",
    name: "UserNotVerified",
    message: "The user has not been verified. Please click link in email.",
    user_visible: true,
    response_code: 401
  },
  {
    code: 18,
    type: "U",
    part: "GE",
    action: "correct",
    name: "UserAlreadyVerified",
    message: "The user has already been verified.",
    user_visible: true,
    response_code: 400
  },
  {
    code: 20,
    type: "O",
    part: "CH",
    action: "error",
    name: "MissingParam",
    message: "Missing parameter to function call"
  },
  {
    code: 21,
    type: "O",
    part: "CH",
    action: "error",
    name: "MalformedTicketDetailsFromAdapter",
    message: "Adapter returned a malformed ticket details object"
  },
  {
    code: 22,
    type: "O",
    part: "GE",
    action: "error",
    name: "ErrorSavingModel",
    message: "Error saving model to database"
  },
  {
    code: 23,
    type: "O",
    part: "GE",
    action: "error",
    name: "ReferencedModelDoesNotExist",
    message: "Cannot find model",
    response_code: 404
  },
  {
    code: 24,
    type: "U",
    part: "GE",
    action: "correct",
    name: "PasswordResetTokenInvalid",
    message: "Password reset token invalid",
    response_code: 422
  },
  {
    code: 31,
    type: "U",
    part: "GE",
    action: "correct",
    name: "UserVerificationTokenInvalid",
    message: "User verification token invalid",
    response_code: 422
  },
  {
    code: 32,
    type: "U",
    part: "GE",
    action: "correct",
    name: "GoogleUserExists",
    message: "A user with this google account already exists",
    user_visible: true,
    response_code: 409
  },
  {
    code: 33,
    type: "O",
    part: "GE",
    action: "error",
    name: "GooglePlatformError",
    message: "Error from the google API",
    user_visible: false,
    response_code: 500
  },
  {
    code: 34,
    type: "O",
    part: "GE",
    action: "error",
    name: "AdapterInitializationError",
    message: "Error initializing adapter",
    user_visible: false,
    response_code: 500
  },
  {
    code: 35,
    type: "O",
    part: "GE",
    action: "error",
    name: "UninitializedAdapterError",
    message: "Adapter has not been initialized",
    user_visible: false,
    response_code: 500
  },
  {
    code: 40,
    type: "O",
    part: "GE",
    action: "error",
    name: "AdapterRateLimitedError",
    message: "Could not make the call to the adapter due to a internal rate limiting policy",
    user_visible: false,
    response_code: 429
  },
  {
    code: 41,
    type: "O",
    part: "GE",
    action: "error",
    name: "MissingTranslation",
    message: "The provided key is not present in the translation file.",
    user_visible: false,
    constructor_arguments: [
      { name: "locale", type: "string" },
      { name: "key", type: "string" }
    ],
    optional_fields: {
      locale: "",
      key: ""
    }
  },
  {
    code: 42,
    type: "O",
    part: "GE",
    action: "error",
    name: "PassengerQuestionKeyUndefined",
    message: "The passenger question key is undefined.",
    user_visible: false
  },
  {
    code: 43,
    type: "O",
    part: "GE",
    action: "error",
    name: "PartnerRateLimited",
    message: "The partner returned that the request was rate limited",
    user_visible: false,
    response_code: 429
  },
  {
    code: 44,
    type: "U",
    part: "GE",
    action: "error",
    name: "UnverifiedProviderIdentityError",
    message: "The provider was not able to provide enough information on user's identity",
    user_visible: true,
    response_code: 400,
    constructor_arguments: [{ name: "provider_name", type: AUTH_PROVIDERS_NAME }],
    optional_fields: {
      provider_name: ""
    },
    optional_definitions: `
      provider_name?: ${AUTH_PROVIDERS_NAME};
    `
  },
  {
    code: 45,
    type: "E",
    part: "SH",
    action: "error",
    name: "CachedTripNotFound",
    message: "Cannot find requested trip in cache",
    response_code: 404
  },

  {
    code: 46,
    type: "O",
    part: "GE",
    action: "error",
    name: "ContextualizedModelNotFound",
    message: "Can not find required contextualized model when producing a response body",
    response_code: 404
  },

  {
    code: 47,
    type: "U",
    part: "SH",
    action: "error",
    name: "TooManyPassengers",
    message: "Cannot execute a search with so many passengers at once",
    response_code: 400
  },

  // Backwards compatibility with Exceptional lib
  {
    code: 25,
    type: "U",
    part: "GE",
    action: "error",
    name: "BadRequest",
    message: "Bad request",
    response_code: 400
  },
  {
    code: 26,
    type: "U",
    part: "GE",
    action: "error",
    name: "Unauthorized",
    message: "Unauthorized",
    response_code: 401
  },
  {
    code: 27,
    type: "O",
    part: "GE",
    action: "error",
    name: "Conflict",
    message: "State conflict",
    response_code: 409
  },
  {
    code: 28,
    type: "O",
    part: "GE",
    action: "error",
    name: "Impossible",
    message: "Request is correctly structured, but data doesn't match up",
    response_code: 422
  },
  {
    code: 29,
    type: "O",
    part: "GE",
    action: "error",
    name: "Unknown",
    message: "Unknown error",
    response_code: 500
  },
  Object.assign(
    {
      code: 30,
      type: "O",
      part: "GE",
      action: "error",
      name: "TimeoutError",
      message: "Timeout error"
    },
    ACCEPT_PARTIAL_BOOKING_DETAILS
  ),

  // Discount code errors
  {
    code: 50,
    type: "U",
    part: "SH",
    action: "correct",
    name: "DiscountCodeInvalid",
    message: "Discount code is invalid or expired",
    response_code: 422
  },
  {
    code: 51,
    type: "U",
    part: "SH",
    action: "correct",
    name: "DiscountCodeInvalidCountry",
    message: "Discount code is invalid for this country",
    response_code: 422
  },
  {
    code: 52,
    type: "U",
    part: "SH",
    action: "correct",
    name: "DiscountCodeInvalidCityPair",
    message: "Discount code is invalid for this city pair",
    response_code: 422
  },
  {
    code: 53,
    type: "U",
    part: "CH",
    action: "correct",
    name: "DiscountCodeInvalidUser",
    message: "Discount code maximum uses per user reached, retry purchase without discount",
    response_code: 422
  },
  {
    code: 54,
    type: "U",
    part: "CH",
    action: "correct",
    name: "DiscountCodeInvalidUserExternal",
    message: "Discount code maximum uses per user reached, go back to search",
    response_code: 422
  },

  // Cart & Booking based errors
  {
    code: 100,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CartNotSet",
    message: "Cart has not been initialized",
    user_visible: false
  },
  {
    code: 101,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CartDepartureNotFound",
    message: "Departure was not found",
    user_visible: false,
    response_code: 404
  },
  {
    code: 102,
    type: "O",
    part: "CH",
    action: "error",
    name: "CartDepartureMissingMappings",
    message: "Departure was not properly mapped",
    user_visible: false,
    response_code: 422
  },
  {
    code: 103,
    type: "O",
    part: "CH",
    action: "correct",
    name: "PassengerCountMismatch",
    message: "Tried to set the wrong number of passengers",
    user_visible: false,
    response_code: 400
  },
  {
    code: 104,
    type: "O",
    part: "CH",
    action: "correct",
    name: "PassengerBadId",
    message: "Passenger ids do not match",
    user_visible: false,
    response_code: 400
  },
  {
    code: 105,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengerQuestionsUnanswered",
    message: "Not all questions answered",
    response_code: 400
  },
  // DELETED: 106 DiscountCodeNotApplicable
  // DELETED: 107 DiscountCodeNotFound
  {
    code: 108,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengersNotSet",
    message: "Passenger information not set",
    user_visible: false,
    response_code: 409
  },
  {
    code: 109,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengerMissingInformation",
    message: "Not all passenger fields filled",
    response_code: 400
  },
  {
    code: 110,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CityNotFound",
    message: "The city does not exist",
    user_visible: false,
    response_code: 404
  },
  {
    code: 111,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengersUpdateFail",
    message: "Request to update passengers fail",
    user_visible: false,
    response_code: 404
  },
  {
    code: 112,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengersUpdateError",
    message: "Request to update passengers return an error",
    user_visible: false,
    response_code: 404
  },
  {
    code: 113,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CartRoundtripNotFound",
    message: "Roundtrip object not found",
    user_visible: false,
    response_code: 404
  },
  {
    code: 114,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CartRoundtripNotApplicable",
    message: "Roundtrip not applicable to chosen departures",
    response_code: 404
  },
  {
    code: 115,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CartDepartureNoLongerAvailable",
    message: "Departure is no longer available",
    response_code: 404
  },
  {
    code: 116,
    type: "U",
    part: "CH",
    action: "correct",
    name: "TicketTypeNotAvailable",
    message: "The ticket type is not available for this departure",
    response_code: 422
  },
  {
    code: 117,
    type: "U",
    part: "CH",
    action: "correct",
    name: "ImpossibleRoundtrip",
    message: "The roundtrip departures combination is impossible",
    response_code: 422,
    user_visible: true
  },
  {
    code: 118,
    type: "U",
    part: "CH",
    action: "correct",
    name: "RoundtripNotSupported",
    message: "The selected roundtrip is not supported at checkout",
    response_code: 400,
    user_visible: true
  },
  {
    code: 119,
    type: "O",
    part: "CH",
    action: "correct",
    name: "PassengerInvalidSeatId",
    message: "The selected seat id is not valid",
    response_code: 400
  },
  {
    code: 120,
    type: "O",
    part: "CH",
    action: "correct",
    name: "OnePrimaryContactPerCart",
    message: "Can only have 1 primary contact per cart",
    response_code: 400
  },
  {
    code: 121,
    type: "O",
    part: "CH",
    action: "correct",
    name: "CartAlreadyBought",
    message: "Cart has already been bought",
    response_code: 410,
    optional_definitions: `
      additional_data: {
        purchase_id: number;
        purchase_uuid: string;
      }
    `
  },
  {
    code: 122,
    type: "O",
    part: "CH",
    action: "correct",
    name: "PaymentTypeNotAvailable",
    message: "The selected payment type is not available for this cart",
    response_code: 400
  },
  {
    code: 123,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengerAnswersNotUnique",
    message: "Passenger answers are not unique",
    user_visible: true,
    response_code: 400
  },
  {
    code: 124,
    type: "U",
    part: "CH",
    action: "error",
    name: "CreditNotAllowed",
    message: "Credit is not allowed for this cart",
    user_visible: true,
    response_code: 400
  },
  {
    code: 125,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CartDepartureExpired",
    message: "Departure was not found and results are now expired. Please poll again",
    user_visible: true,
    response_code: 404
  },
  {
    code: 126,
    type: "U",
    part: "CH",
    action: "correct",
    name: "WheelchairNotAvailable",
    message: "Wheelchairs are not available for the selected departure",
    user_visible: true,
    response_code: 400
  },
  {
    code: 127,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengerAddonsInvalid",
    message: "Selected addons are invalid",
    user_visible: false,
    response_code: 400
  },
  {
    code: 128,
    type: "U",
    part: "CH",
    action: "correct",
    name: "DepartureNotYetBookable",
    message: "This departure can not be booked this far in advance",
    user_visible: false,
    response_code: 400
  },
  {
    code: 129,
    type: "U",
    part: "CH",
    action: "correct",
    name: "BookingDepartureNoLongerAvailable",
    message: "Departure is no longer available",
    response_code: 404
  },
  {
    code: 130,
    type: "U",
    part: "CH",
    action: "correct",
    name: "BookingDepartureExpired",
    message: "Departure was not found and results are now expired. Please poll again",
    user_visible: true,
    response_code: 404
  },
  {
    code: 131,
    type: "O",
    part: "CH",
    action: "error",
    name: "BusLayoutInvalid",
    message: "The bus layout is invalid.",
    response_code: 422
  },
  {
    code: 132,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PassengerAnswersInvalid",
    message: "Partner reports a passenger question response to be invalid",
    user_visible: true,
    response_code: 400,
    optional_fields: {
      errors: []
    },
    optional_definitions: `
      errors: {
        passenger_id: string;
        question_key: string;
        error_message?: string;
      }[];
    `
  },

  // Purchase Processing errors
  {
    code: 200,
    type: "U",
    part: "CH",
    action: "correct",
    name: "CartInvalidPaymentToken",
    message: "Cart payment token provided is invalid",
    user_visible: false
  },
  {
    code: 201,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseAlreadyBooked",
    message: "Can't process an already booked purchase again"
  },
  {
    code: 202,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseErrored",
    message: "Can't process a purchase that errored"
  },
  {
    code: 203,
    type: "O",
    part: "CH",
    action: "correct",
    name: "PurchaseDepartureInvalid",
    message: "Purchase has an invalid departure"
  },
  {
    code: 204,
    type: "O",
    part: "CH",
    action: "correct",
    name: "PurchaseDepartureCapacityExceeded",
    message: "Purchase has a departure wich exceeded its capacity limit"
  },
  {
    code: 205,
    type: "O",
    part: "CH",
    action: "error",
    name: "BookingServiceFailedToCancel",
    message: "Booking service failed to cancel during purchase process"
  },
  {
    code: 206,
    type: "O",
    part: "CH",
    action: "error",
    name: "PaymentInfoMissing",
    message: "Purchase failed to missing payment informations"
  },
  {
    code: 207,
    type: "O",
    part: "CH",
    action: "error",
    name: "SpreedlyTokenNotSet",
    message: "Spreedly token are not set on busbud config"
  },
  {
    code: 208,
    type: "O",
    part: "CH",
    action: "error",
    name: "SpreedlyTokenFail",
    message: "Request to retrieve a spreedly token fail"
  },
  {
    code: 209,
    type: "O",
    part: "CH",
    action: "error",
    name: "SpreedlyTokenError",
    message: "Request to retrieve a spreedly token return an error",
    user_visible: true
  },
  {
    code: 210,
    type: "O",
    part: "CH",
    action: "error",
    name: "TransactionNotRefundable",
    message: "Cannot refund this transaction"
  },
  {
    code: 211,
    type: "O",
    part: "CH",
    action: "error",
    name: "TransactionAlreadyRefunded",
    message: "Transaction is already refunded",
    response_code: 409
  },
  {
    code: 212,
    type: "O",
    part: "CH",
    action: "error",
    name: "TransactionRefundTooMuch",
    message: "Cannot refund more than the transaction amount"
  },
  {
    code: 213,
    type: "O",
    part: "CH",
    action: "error",
    name: "TransactionNotRefundableExternal",
    message: "Cannot refund an externally charged transaction"
  },
  {
    code: 214,
    type: "O",
    part: "CH",
    action: "error",
    name: "RoundtripDepartureBookedNotCancelled",
    message: "One departure in the roundtrip was booked but not cancelled"
  },
  {
    code: 215,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchasePaused",
    message: "Purchase has been paused."
  },
  {
    code: 216,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseResumeError",
    message: "Error resuming purchase."
  },
  {
    code: 218,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseNotRefundable",
    message: "Purchase is not refundable",
    response_code: 400
  },
  {
    code: 219,
    type: "O",
    part: "CH",
    action: "error",
    name: "InsufficientCredits",
    message: "Insufficient credits available to complete transaction",
    response_code: 400,
    user_visible: true
  },
  {
    code: 220,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseAlreadyCancelled",
    message: "Can't process an already cancelled purchase again",
    response_code: 409
  },
  {
    code: 221,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseDelayed",
    message: "Purchase has been delayed."
  },
  {
    code: 222,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseActionNeeded",
    message: "Purchase action needed."
  },
  {
    code: 223,
    type: "O",
    part: "CH",
    action: "error",
    name: "PaymentDelayed",
    message: "Payment has been delayed."
  },
  {
    code: 224,
    type: "O",
    part: "CH",
    action: "error",
    name: "PurchaseActionInvalid",
    message: "Purchase action is not valid",
    response_code: 400
  },
  {
    code: 225,
    type: "O",
    part: "CH",
    action: "error",
    name: "DeriskFailed",
    message: "Failed to get decision to derisk a purchase attempt"
  },
  {
    code: 226,
    type: "O",
    part: "CH",
    action: "error",
    name: "AmountMismatch",
    message: "Mismatch between the cart amount and the final amount.",
    response_code: 409
  },
  {
    code: 227,
    type: "O",
    part: "CH",
    action: "error",
    name: "GatewayUnavailable",
    message: "Gateway seems to be unavailable, consider using another one."
  },
  {
    code: 228,
    type: "O",
    part: "BO",
    action: "error",
    name: "AncillaryItemUnavailable",
    message: "Could not purchase the ancillary item",
    user_visible: true,
    response_code: 409
  },

  // Adapters errors
  {
    code: 301,
    type: "O",
    part: "BO",
    action: "error",
    name: "InvalidXDeparture",
    message: "Invalid XDepature"
  },
  {
    code: 302,
    type: "E",
    part: "BO",
    action: "error",
    name: "CreditCardDeniedExternal",
    message: "External source denied credit card",
    user_visible: true
  },
  {
    code: 303,
    type: "E",
    part: "BO",
    action: "error",
    name: "NoSeatsAvailable",
    message: "No more seats available",
    user_visible: true,
    response_code: 410
  },
  {
    code: 304,
    type: "E",
    part: "IM",
    action: "error",
    name: "NoDetailsForLocation",
    message: "Could not find details for location"
  },
  {
    code: 305,
    type: "E",
    part: "BO",
    action: "retry",
    name: "ServerTooBusy",
    message: "Server too busy"
  },
  {
    code: 306,
    type: "E",
    part: "SH",
    action: "error",
    name: "RouteNotAvailable",
    message: "Route does not exist",
    response_code: 404
  },
  {
    code: 307,
    type: "E",
    part: "SH",
    action: "error",
    name: "ScheduleNotFound",
    message: "No schedule information available"
  },
  {
    code: 308,
    type: "E",
    part: "SH",
    action: "retry",
    name: "RequestTimedOut",
    message: "Request timed out"
  },
  {
    code: 309,
    type: "E",
    part: "SH",
    action: "error",
    name: "UnexpectedResponse",
    message: "Unexpected response"
  },
  {
    code: 310,
    type: "E",
    part: "BO",
    action: "error",
    name: "TicketNotCancellable",
    message: "Ticket is not cancellable",
    user_visible: true,
    response_code: 400
  },
  {
    code: 311,
    type: "E",
    part: "BO",
    action: "retry",
    name: "CannotFetchSeatingChart",
    message: "Cannot fetch seating chart"
  },
  {
    code: 312,
    type: "E",
    part: "BO",
    action: "error",
    name: "PastBuyCutoff",
    message: "Past cutoff time to buy ticket",
    user_visible: true,
    response_code: 422
  },
  {
    code: 313,
    type: "E",
    part: "BO",
    action: "error",
    name: "NotEnoughSeatsForAllPassengers",
    message: "Not enough seats for all passengers",
    response_code: 422
  },
  {
    code: 314,
    type: "O",
    part: "BO",
    action: "error",
    name: "GovernmentIdRequired",
    message: "Government ID required",
    user_visible: true,
    response_code: 400
  },
  {
    code: 315,
    type: "O",
    part: "SH",
    action: "error",
    name: "MalformedRequest",
    message: "The request could not be understood by the server due to malformed syntax",
    response_code: 422
  },
  Object.assign(
    {
      code: 316,
      type: "O",
      part: "BO",
      action: "error",
      name: "CouldNotBookTicketsForAllPassengers",
      description:
        "Meant to be used when the supplier's `book` method requires one call per passenger and at least one ticket was booked when the rest failed.",
      message: "Could not book tickets for all passengers"
    },
    ACCEPT_PARTIAL_BOOKING_DETAILS
  ),
  {
    code: 317,
    type: "E",
    part: "BO",
    action: "retry",
    name: "CouldNotGetTicketFiles",
    message: "Coult not get tickets files for all passengers"
  },
  {
    code: 318,
    type: "E",
    part: "SH",
    action: "error",
    name: "LocationNotFound",
    message: "Location not found"
  },
  {
    code: 319,
    type: "E",
    part: "SH",
    action: "error",
    name: "DepartureNotFound",
    message: "Departure not found on external system",
    response_code: 404
  },
  {
    code: 320,
    type: "E",
    part: "BO",
    action: "error",
    name: "InvalidPrice",
    message: "Departure price is no longer valid",
    user_visible: true,
    response_code: 409,
    constructor_arguments: [
      { name: "message", type: "string" },
      { name: "original_prices", type: "Prices" },
      { name: "updated_prices", type: "Prices" }
    ],
    optional_fields: {
      original_prices: undefined,
      updated_prices: undefined
    },
    optional_definitions: `
      original_prices?: Prices;
      updated_prices?: Prices;
    `
  },
  {
    code: 321,
    type: "E",
    part: "BO",
    action: "retry",
    user_visible: true,
    name: "SelectedSeatsNotAvailable",
    message: "Seats selected are not available",
    response_code: 410
  },
  Object.assign(
    {
      code: 322,
      type: "E",
      part: "BO",
      action: "error",
      name: "TemporaryExternalError",
      message: "Temporary issue with the external system, please try again"
    },
    ACCEPT_PARTIAL_BOOKING_DETAILS
  ),
  {
    code: 323,
    type: "E",
    part: "SH",
    action: "error",
    name: "SourceAPIBlocked",
    message: "The source API has blocked us and may require manual intervention to repair"
  },
  {
    code: 324,
    type: "U",
    part: "CH",
    action: "error",
    name: "UnaccompaniedMinorNotAllowed",
    message: "Unaccompanied minor not allowed",
    response_code: 400
  },
  {
    code: 325,
    type: "U",
    part: "CH",
    action: "error",
    name: "TurkishIDValidationError",
    user_visible: true,
    response_code: 400
  },
  {
    code: 326,
    type: "E",
    part: "BO",
    action: "retry",
    user_visible: true,
    name: "InvalidSeatSelection",
    message: "The seats are not available for booking anymore",
    constructor_arguments: [{ name: "seats", type: "string[]" }],
    optional_fields: {
      seats: []
    },
    response_code: 410
  },
  {
    code: 327,
    type: "E",
    part: "SH",
    action: "correct",
    name: "SearchDateOutOfRange",
    message: "The search date is not supported by source API because it is far too in advance",
    user_visible: false,
    response_code: 422
  },
  {
    code: 328,
    type: "E",
    part: "GE",
    action: "error",
    name: "PartnerServiceUnavailable",
    message: "The partner API is currently down for maintenance",
    user_visible: false,
    response_code: 503
  },
  {
    code: 329,
    type: "E",
    part: "BO",
    action: "error",
    name: "PartnerLoyaltyProgramError",
    message: "Loyalty program issue on the partner side",
    description:
      "This error is meant to be thrown when the partner rejects the request because of a loyalty program issue",
    optional_fields: {
      reason: ""
    },
    optional_definitions: "reason?: string;",
    user_visible: true
  },
  // Transaction errors
  {
    code: 400,
    type: "U",
    part: "CH",
    action: "correct",
    name: "TransactionDeclined",
    message: "Transaction was declined",
    user_visible: true
  },
  {
    code: 401,
    type: "O",
    part: "CH",
    action: "retry",
    name: "TransactionTimeout",
    message: "Payment system not responding",
    user_visible: true
  },
  {
    code: 402,
    type: "U",
    part: "CH",
    action: "correct",
    name: "TransactionCardNotSupported",
    message: "Credit card type not supported",
    user_visible: true
  },
  {
    code: 403,
    type: "U",
    part: "CH",
    action: "correct",
    name: "TransactionDuplicate",
    message: "Duplicate transaction",
    user_visible: true
  },
  {
    code: 404,
    type: "U",
    part: "CH",
    action: "correct",
    name: "TransactionVelocity",
    message: "Maximum number of attempts reached",
    user_visible: true
  },
  {
    code: 405,
    type: "U",
    part: "CH",
    action: "correct",
    name: "TransactionCardInfoIncorrect",
    message: "Card information is incorrect",
    user_visible: true
  },
  {
    code: 406,
    type: "O",
    part: "CH",
    action: "error",
    name: "TransactionContactSupport",
    message: "Unrecognized error occured, contact support",
    user_visible: true
  },
  {
    code: 407,
    type: "O",
    part: "CH",
    action: "error",
    name: "PaypalAuthorizeFailure",
    message: "Paypal authorization finished in a bad state",
    user_visible: false
  },
  {
    code: 408,
    type: "O",
    part: "CH",
    action: "error",
    name: "PaypalCaptureFailure",
    message: "Paypal capture finished in a bad state",
    user_visible: false
  },
  {
    code: 409,
    type: "O",
    part: "CH",
    action: "error",
    name: "PaypalSetupFailed",
    message: "Failed to setup Paypal express checkout",
    user_visible: true
  },
  {
    code: 410,
    type: "O",
    part: "CH",
    action: "error",
    name: "PaypalTransactionFailed",
    message: "Paypal transaction failed",
    user_visible: true
  },
  {
    code: 411,
    type: "O",
    part: "CH",
    action: "retry",
    name: "PaypalCustomerDetailsFailed",
    message: "We were not able to fetch customer info from Paypal",
    user_visible: false
  },
  {
    code: 412,
    type: "O",
    part: "CH",
    action: "error",
    name: "PaypalRefundFailure",
    message: "We were not able to refund this transaction with Paypal",
    user_visible: false
  },
  {
    code: 413,
    type: "O",
    part: "CH",
    action: "error",
    name: "TransactionVoidFailed",
    message: "Failed to void transaction",
    user_visible: false
  },
  {
    code: 416,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenCancelFailed",
    message: "We were not able to cancel this transaction with Adyen",
    user_visible: false
  },
  {
    code: 417,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenRefundFailed",
    message: "We were not able to refund this transaction with Adyen",
    user_visible: false
  },
  {
    code: 418,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenCancelRequestFailed",
    message: "We were not able to request a cancel with Adyen for this transaction",
    user_visible: false
  },
  {
    code: 419,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenRefundRequestFailed",
    message: "We were not able to request a refund with Adyen for this transaction",
    user_visible: false
  },
  {
    code: 420,
    type: "O",
    part: "CH",
    action: "error",
    name: "TransactionFailed",
    message: "Unrecognized error occured",
    user_visible: true
  },
  {
    code: 421,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenCaptureRequestFailed",
    message: "We were not able to request a capture with Adyen for this transaction",
    user_visible: false
  },
  {
    code: 422,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenCaptureFailed",
    message: "We were not able to capture this transaction with Adyen",
    user_visible: false
  },
  {
    code: 423,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenAuthorizeRequestFailed",
    message: "We were not able to request an authorization with Adyen for this transaction",
    user_visible: false
  },
  {
    code: 424,
    type: "U",
    part: "CH",
    action: "correct",
    name: "UnavailablePaymentType",
    message: "The requested payment type is not available for the current context",
    user_visible: false,
    response_code: 422
  },
  {
    code: 425,
    type: "O",
    part: "CH",
    action: "error",
    name: "AdyenCancelOrRefundRequestFailed",
    message: "We were not able to request a cancelOrRefund with Adyen for this transaction",
    user_visible: false
  },
  {
    code: 426,
    type: "U",
    part: "CH",
    action: "correct",
    name: "InsufficientBalance",
    message: "Card limit or balance is insufficient",
    user_visible: true
  },
  {
    code: 427,
    type: "U",
    part: "CH",
    action: "correct",
    name: "InstallmentsNotSupported",
    message: "Card does not support installments",
    user_visible: true
  },
  {
    code: 428,
    type: "U",
    part: "CH",
    action: "correct",
    name: "PurchaseAbandoned",
    message: "User abandoned the purchase",
    user_visible: true
  },

  // Search errors
  {
    code: 500,
    type: "O",
    part: "SH",
    action: "error",
    name: "DuplicateDeparturesInResults",
    message: "Duplicate departures found on route",
    user_visible: false
  },
  {
    code: 501,
    type: "O",
    part: "SH",
    action: "error",
    name: "InvalidOutboundDeparture",
    message: "Selected outbound departure is invalid",
    response_code: 400,
    user_visible: false
  },
  {
    code: 502,
    type: "O",
    part: "SH",
    action: "error",
    name: "UninitializedFetchError",
    message: "Search was not initialized",
    response_code: 409,
    user_visible: false
  },

  // Global NAPI errors
  {
    code: 600,
    type: "O",
    part: "GE",
    action: "error",
    name: "RabbitMQConnectionFailure",
    message: "Failed to connect to RabbitMQ server",
    user_visible: false
  },
  {
    code: 601,
    type: "O",
    part: "GE",
    action: "error",
    name: "PublishEventFailed",
    message: "Failed to publish event to RabbitMQ server",
    user_visible: false
  },
  {
    code: 602,
    type: "O",
    part: "GE",
    action: "error",
    name: "EmailSendingFailed",
    message: "Failed to send email",
    user_visible: false
  },

  // Authentication Errors
  {
    code: 700,
    type: "O",
    part: "GE",
    action: "error",
    name: "TokenRequired",
    message: "Authentication token is missing",
    user_visible: false,
    response_code: 401
  },
  {
    code: 701,
    type: "O",
    part: "GE",
    action: "error",
    name: "PrivateTokenRequired",
    message: "A private token is required",
    user_visible: false,
    response_code: 401
  },
  {
    code: 702,
    type: "O",
    part: "CH",
    action: "error",
    name: "PartnerSourceDenied",
    message: "The partner does not have access to the source",
    user_visible: false,
    response_code: 401
  },
  {
    code: 703,
    type: "O",
    part: "CH",
    action: "error",
    name: "PartnerPurchaseDenied",
    message: "The partner is not setup to buy tickets",
    user_visible: false,
    response_code: 401
  },
  {
    code: 704,
    type: "O",
    part: "GE", // Used during search and booking
    action: "error",
    name: "PartnerDiscountCodeUnauthorized",
    message: "The partner is not authorized to use discount codes",
    user_visible: false,
    response_code: 401
  },
  {
    code: 705,
    type: "O",
    part: "GE",
    action: "error",
    name: "PartnerInvalidApiVersion",
    message: "Invalid API version for partner",
    user_visible: false,
    response_code: 401
  },
  {
    code: 706,
    type: "O",
    part: "GE",
    action: "error",
    name: "PartnerNotActivated",
    message: "The partner is not activated",
    user_visible: false,
    response_code: 401
  },

  // Front end errors
  {
    code: 800,
    type: "O",
    part: "GE",
    action: "retry",
    name: "CannotReachAPI",
    message: "Cannot reach server",
    user_visible: false
  },
  {
    code: 801,
    type: "O",
    part: "GE",
    action: "retry",
    name: "ResponseNotJSON",
    message: "Server did not return JSON",
    user_visible: false
  },
  {
    code: 802,
    type: "O",
    part: "GE",
    action: "error",
    name: "PollLimitReached",
    message: "Poll limit reached",
    user_visible: false
  },
  {
    code: 803,
    type: "U",
    part: "GE",
    action: "error",
    name: "GeneralError",
    message: "Something went wrong",
    user_visible: true
  },
  {
    code: 804,
    type: "O",
    part: "CH",
    action: "error",
    name: "TicketGeneratingPollLimitReached",
    message: "Ticket can't be generated",
    user_visible: true
  },

  // Verification (security checks) errors
  {
    code: 900,
    type: "U",
    part: "GE",
    action: "correct",
    name: "InvalidCode",
    message: "Invalid verification code",
    user_visible: true,
    response_code: 403
  },
  {
    code: 901,
    type: "O",
    part: "BO",
    action: "error",
    name: "AlertTriggeringError",
    description: "An error that will trigger an alert in one of our communication channels.",
    message: "",
    optional_fields: {
      channels_to_receive_alert: []
    }
  },
  {
    code: 1000,
    type: "E",
    part: "BO",
    action: "error",
    name: "PurchaseCancellationDenied",
    message: "Purchase could not be cancelled because it was denied by the bus company.",
    description:
      "This error is meant to be thrown when the partner specified a valid reason for not canceling the ticket (i.e.: when the user already printed the ticket at the station).",
    optional_fields: {
      reason: ""
    },
    optional_definitions: "reason?: string;",
    response_code: 400
  },
  {
    code: 1001,
    type: "O",
    part: "BO",
    action: "error",
    name: "PurchaseCancellationPending",
    message: "Purchase could not be cancelled because cancellation is already pending",
    response_code: 400
  },
  {
    code: 1002,
    type: "U",
    part: "GE",
    action: "correct",
    name: "AppleUserExists",
    message: "A user with the apple id account already exists",
    user_visible: true,
    response_code: 409
  },
  {
    code: 1003,
    type: "U",
    part: "GE",
    action: "correct",
    name: "UserEmailVerificationRequired",
    message:
      "The email associated to this account needs to be verified. An email with a verification link has been sent.",
    user_visible: true,
    response_code: 401
  }
];
